import ScannerLayout from "./ScannerLayout"

const ErrorPage = () => {
 return (
    <ScannerLayout>
        <p>Page not found</p>
    </ScannerLayout>
 );
};

export default ErrorPage;